import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import Login     from './pages/Login';
import Signup    from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Quotes    from './pages/Quotes';
import Settings  from './pages/Settings';
import Admin from './pages/Admin';

const qc   = new QueryClient();
const auth = () => !!localStorage.getItem('token');

export default function App() {
  return (
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login"     element={<Login />} />
          <Route path="/signup"    element={<Signup />} />
          <Route path="/dashboard" element={auth() ? <Dashboard /> : <Navigate to="/login" />} />
          <Route path="/quotes"    element={auth() ? <Quotes />    : <Navigate to="/login" />} />
          <Route path="/settings"  element={auth() ? <Settings />  : <Navigate to="/login" />} />
          <Route path="*"          element={<Navigate to={auth() ? '/dashboard' : '/login'} />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}